import Home from './components/Home.vue';

const About = resolve => {
  require.ensure(['./components/About.vue'], () => {
    resolve(require('./components/About.vue'));
  })
};

const Listings = resolve => {
  require.ensure(['./components/Listings.vue'], () => {
    resolve(require('./components/Listings.vue'));
  })
};

const Listing = resolve => {
  require.ensure(['./components/Listing.vue'], () => {
    resolve(require('./components/Listing.vue'));
  })
};

const MortgageCalculator = resolve => {
  require.ensure(['./components/MortgageCalculator.vue'], () => {
    resolve(require('./components/MortgageCalculator.vue'));
  })
};

const Foreclosure = resolve => {
  require.ensure(['./components/Foreclosure.vue'], () => {
    resolve(require('./components/Foreclosure.vue'));
  })
};

const BuyersCenter = resolve => {
  require.ensure(['./components/BuyersCenter.vue'], () => {
    resolve(require('./components/BuyersCenter.vue'));
  })
};

const SellersCenter = resolve => {
  require.ensure(['./components/SellersCenter.vue'], () => {
    resolve(require('./components/SellersCenter.vue'));
  })
};

const ListingDetail = resolve => {
  require.ensure(['./components/ListingDetail.vue'], () => {
    resolve(require('./components/ListingDetail.vue'));
  })
};

const ListingMap = resolve => {
  require.ensure(['./components/ListingMap.vue'], () => {
    resolve(require('./components/ListingMap.vue'));
  })
};

const ListingSchools = resolve => {
  require.ensure(['./components/ListingSchools.vue'], () => {
    resolve(require('./components/ListingSchools.vue'));
  })
};

const ListingCommunityInfo = resolve => {
  require.ensure(['./components/ListingCommunityInfo.vue'], () => {
    resolve(require('./components/ListingCommunityInfo.vue'));
  })
};

export const routes = [
    {
      path: '',
      component: Home
    },
    {
      path: '/about',
      component: About
    },
    {
      path: '/listings/:type',
      props: true,
      component: Listings
    },
    {
      path: '/listing/:id',
      props: true,
      component: Listing,
      children: [
        {
          name: 'listing',
          path: 'detail',
          component: ListingDetail,
          props: true,
        },
        {
          path: 'map',
          component: ListingMap,
          props: true,
        },
        {
          path: 'schools',
          component: ListingSchools,
          props: true,
        },
        {
          path: 'communityinfo',
          component: ListingCommunityInfo,
          props: true,
        }
      ]
    },
    {
      path: '/mortgagecalculator',
      component:
      MortgageCalculator
    }
    ,
    {
      path: '/foreclosure',
      component:
      Foreclosure
    }
    ,
    {
      path: '/buyerscenter',
      component:
      BuyersCenter
    }
    ,
    {
      path: '/sellerscenter',
      component:
      SellersCenter
    }
  ]
;


// WEBPACK FOOTER //
// ./src/routes.js